import { Back, TweenLite } from 'gsap';
import { GameAudio } from '../../Config/Audio';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
import Core, { GameOrientation } from '../../Core/Core';
import SoundManager from '../../Sound/SoundManager';
import { PopupActions } from '../../State/Actions/Actions';
import { Animation } from '../Animations/Animation';
import MultiStyleText from '../Shared/Text/MultiStyleText';
import { ITweenable } from './ITweenable';

export class FailflowPopup extends PIXI.Container implements ITweenable {
    protected readonly popupContainer: PIXI.Sprite;
    protected bg: PIXI.Sprite;
    protected shuffleText: PIXI.Text;

    constructor() {
        super();
        const mainText = 'FailFlowUseBoosters';
        const popupContainer = new PIXI.Sprite();
        const bg = new PIXI.Sprite(PIXI.utils.TextureCache['gameui/booster-ribbon']);
        this.bg = bg;

        const shuffleText = new MultiStyleText(Core.local.getText(mainText), {
            default: {
                align: 'center',
                fill: 0xffffff,
                fontFamily: Core.local.languageKey === 'ru' ? 'Marmelad' : 'Baloo',
                fontSize: 33,
                lineHeight: 28,
                wordWrap: true,
                wordWrapWidth: bg.width,
            },
            high: {
                fill: 0xffeb00,
            },
        });

        shuffleText.anchor.set(0.5);

        this.shuffleText = shuffleText;
        popupContainer.addChild(bg, shuffleText);
        this.addChild(popupContainer);
        this.popupContainer = popupContainer;

        this.resize(getGameSize());
    }

    public async tweenIn() {
        const animation = new Animation({});
        animation.add(() => SoundManager.playSound(GameAudio.SHUFFLE_POPUP));

        const gameSize = getGameSize();
        const yPos =
            Core.orientation === GameOrientation.PORTRAIT
                ? gameSize.gameHeight - gameSize.gameHeight * 0.27
                : gameSize.gameHeight * 0.05;
        animation.add(
            TweenLite.to(this.popupContainer, 0.5, {
                ease: Back.easeOut.config(2),
                y: yPos,
            })
        );
        return animation.play();
    }

    public tweenOut() {
        const gameSize = getGameSize();
        SoundManager.playSound(GameAudio.SHUFFLE_POPUP);
        TweenLite.to(this.popupContainer, 0.7, {
            ease: Back.easeOut.config(2),
            onComplete: () => {
                this.emit(PopupActions.STUCK_COMPLETE);
                this.destroy();
            },
            y: gameSize.gameHeight,
        });
    }

    public resize(sizeInfo: IGameSizeInfo) {
        const { bg, shuffleText, popupContainer } = this;
        bg.scale.set(sizeInfo.gameWidth / bg.width, 1);
        shuffleText.x = sizeInfo.gameWidth / 2;
        shuffleText.y = bg.height * 0.45;
        popupContainer.x = 0;
        popupContainer.y = sizeInfo.gameHeight;
    }
}
